/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import { ROUTES } from "@bms/common";
import cx from "classnames";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useHistory, useLocation } from "react-router";

import { Input } from "components";

import { HeaderSearchIcon } from "../HeaderSearchIcon";
import { SearchSuggestions } from "../SearchSuggestions";
import { useAppSearch } from "../useAppSearch";

import "./ApplicationHeaderSearch.scss";

interface ILocationState {
  focusInput: boolean | undefined;
}

export const ApplicationHeaderSearch = () => {
  const {
    isFocused,
    searchComponent,
    searchQuery,
    isApplicationHeaderPlacement,
    handleOnFocus,
    handleOnBlur,
    handleChange,
  } = useAppSearch();

  const { t } = useTranslation();
  const history = useHistory();
  const location = useLocation<ILocationState>();

  const shouldFocusInput = location.state?.focusInput;

  useEffect(() => {
    if (shouldFocusInput) {
      history.replace({ pathname: ROUTES.SEARCH_SCREEN });
    }
  }, [shouldFocusInput, history]);

  const renderInput = () => (
    <>
      <label htmlFor="app-header-search" className="label--hidden">
        {t("SEARCH__INPUT_LABEL")}
      </label>
      <Input
        id="app-header-search"
        allowClear={true}
        autoFocus={!!searchQuery.query || shouldFocusInput}
        value={searchQuery.query}
        placeholder={t("SEARCH__INPUT_PLACEHOLDER")}
        suffix={<HeaderSearchIcon iconUrl={searchComponent?.IconUrl} />}
        onChange={handleChange}
        onFocus={handleOnFocus}
        onBlur={handleOnBlur}
      />
    </>
  );

  return (
    <div
      className={cx("ApplicationHeaderSearch", {
        "ApplicationHeaderSearch--value":
          isApplicationHeaderPlacement && searchQuery.query,
        "ApplicationHeaderSearch--focused":
          isApplicationHeaderPlacement && isFocused,
      })}
    >
      {isApplicationHeaderPlacement ? (
        renderInput()
      ) : (
        <div className="ApplicationHeaderSearch__IconWrapper">
          <HeaderSearchIcon iconUrl={searchComponent?.IconUrl} />
        </div>
      )}
      {isApplicationHeaderPlacement && <SearchSuggestions />}
    </div>
  );
};
